module.exports = __webpack_public_path__ + "img/credit-card-providers.3b14f52.webp";